import Vue from 'vue'
import App from './app.vue'
import store from './store/store'
import Sounds from './libs/sounds'
import _ from 'lodash'
import { VueHammer } from 'vue2-hammer'
import Vuebar from 'vuebar'

Vue.use(VueHammer)
Vue.use(Vuebar)

window.Sounds = Sounds
Object.defineProperty(Vue.prototype, '_', { value: _ });
// Object.defineProperty(Vue.prototype, 'Sounds', { value: Sounds });

Vue.config.productionTip = false

new Vue({
	store,
	render: h => h(App)
}).$mount('#app')

